import { Component } from '@angular/core';
import { LoyaltyService } from '../../../services/loyalty.service';
import { PanelModule } from '../../../modules/panel.module';
import { RewardSaveComponent } from '../reward-save/reward-save.component';
import { InputSwitchModule } from 'primeng/inputswitch';

@Component({
  selector: 'brt-reward-list',
  standalone: true,
  imports: [PanelModule, InputSwitchModule, RewardSaveComponent],
  templateUrl: './reward-list.component.html',
  styleUrl: './reward-list.component.css'
})
export class RewardListComponent {
  constructor(private loyaltyService: LoyaltyService) { }

  rewards: any[];
  async ngOnInit() {
    await this.load();
  }

  detail: any = {};
  dialogVisible: boolean;
  async load() {
    delete this.dialogVisible;
    this.rewards = await this.loyaltyService.getRewards('admin');
  }

  async save(reward: any) {
    await this.loyaltyService.saveReward(reward);
  }
}
